import { render, staticRenderFns } from "./GrundstockImport.vue?vue&type=template&id=2038e1f0&"
import script from "./GrundstockImport.vue?vue&type=script&lang=js&"
export * from "./GrundstockImport.vue?vue&type=script&lang=js&"
import style0 from "./GrundstockImport.vue?vue&type=style&index=0&id=2038e1f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports